import AppIcon from '../components/AppIcon';
import React from 'react';

function AboutPage() {

  const features = [
    { icon: 'family-tree', title: 'Family Tree', desc: 'Visualize your family connections with interactive tree views' },
    { icon: 'book', title: 'Kinship Terms', desc: 'Learn and preserve traditional Mien kinship terminology' },
    { icon: 'image', title: 'Memories', desc: 'Share photos, stories, audio, and video with your family' },
    { icon: 'mail', title: 'Invitations', desc: 'Invite relatives to join and grow your family tree' },
    { icon: 'cultural', title: 'Cultural Terms', desc: 'Explore and learn Mien cultural terms with audio pronunciation' },
    { icon: 'privacy', title: 'Privacy', desc: 'Control who sees what with granular privacy settings' },
  ];

  const techStack = [
    { name: 'React', desc: 'Frontend framework' },
    { name: 'Tailwind CSS', desc: 'Utility-first styling' },
    { name: 'Go', desc: 'Backend language' },
    { name: 'GraphQL', desc: 'API layer' },
    { name: 'PostgreSQL', desc: 'Database' },
  ];

  return (
    <div className="">

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
        {/* Hero */}
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-indigo-600 mb-4">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-gray-900">Mien Family</h2>
          <p className="mt-2 text-lg text-gray-600">Preserving Mien family connections and cultural heritage for future generations.</p>
          <p className="mt-1 text-sm text-gray-400">Version 0.1.0</p>
        </div>

        {/* Features */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">Features</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((f) => (
              <div key={f.title} className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
                <AppIcon name={f.icon} size={24} />
                <h4 className="mt-2 text-sm font-semibold text-gray-900">{f.title}</h4>
                <p className="mt-1 text-xs text-gray-500">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Tech Stack */}
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">Built With</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {techStack.map((t) => (
              <div key={t.name} className="px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-100 text-center">
                <p className="text-sm font-semibold text-gray-900">{t.name}</p>
                <p className="text-xs text-gray-500">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mission */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Our Mission</h3>
          <p className="text-gray-600 leading-relaxed">
            Mien Family is dedicated to preserving and strengthening Mien family connections and cultural heritage. 
            We believe that understanding our kinship terms, sharing our stories, and keeping our families connected 
            is essential for passing our traditions to future generations.
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-3">
          <a href="/help" className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"><AppIcon name="help" size={14} /> Help Center</a>
          <a href="#" className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"><AppIcon name="privacy" size={14} /> Privacy Policy</a>
          <a href="#" className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"><AppIcon name="terms" size={14} /> Terms of Service</a>
          <a href="#" className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"><AppIcon name="bug" size={14} /> Report a Bug</a>
          <a href="#" className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"><AppIcon name="lightbulb" size={14} /> Suggest a Feature</a>
        </div>

        {/* Credits */}
        <div className="text-center text-xs text-gray-400">
          <p>© {new Date().getFullYear()} Mien Family. All rights reserved.</p>
          <p className="mt-1">Made with ❤ for the Mien community.</p>
        </div>
      </main>
    </div>
  );
}

export default AboutPage;